// src/EnhancedComponents/ColorModeToggle.js
import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { useColorScheme } from "@mui/material/styles";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";

/** Light/dark switch. Defaults to the OS preference; the choice is persisted. */
export default function ColorModeToggle({ sx }) {
  const { mode, systemMode, setMode } = useColorScheme();
  if (!mode) return null; // not resolved yet (first paint)

  const resolved = mode === "system" ? systemMode : mode;
  const next = resolved === "dark" ? "light" : "dark";
  const label = `Switch to ${next} mode`;

  return (
    <Tooltip title={label}>
      <IconButton onClick={() => setMode(next)} aria-label={label} color="inherit" sx={sx}>
        {resolved === "dark" ? <LightModeRoundedIcon /> : <DarkModeRoundedIcon />}
      </IconButton>
    </Tooltip>
  );
}
